module.exports = __webpack_public_path__ + "img/numero1.4c48787d.svg";